import { createMessageFormatter, getMessage } from '@theorchard/utils-i18n';
import { renderMessage } from './render';
import { transformMessage } from './transform';
export function createMessageFormatters(messages, options) {
    return {
        t: createMessageFormatter(messages, options),
        tx: (term, args) => {
            const message = getMessage(messages, term, args, options);
            const transformed = transformMessage(message, args);
            return renderMessage(transformed);
        },
    };
}
//# sourceMappingURL=index.js.map